import { OverlayLifecycle } from './overlay-lifecycle.js';

class CollectionFilterController extends HTMLElement {
  connectedCallback() {
    this.disconnect();
    this.resetSubmission();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('[data-collection-filter-dialog]');
    this.fallback = this.querySelector('[data-collection-filter-fallback]');
    this.openButton = this.querySelector('[data-open-collection-filters]');
    this.closeButton = this.querySelector('[data-close-collection-filters]');
    this.form = this.dialog?.querySelector('[data-collection-filter-form]');
    this.sortForm = this.querySelector('[data-collection-sort-form]');
    this.sortMenu = this.querySelector('[data-sort-menu]');
    // The sort menu is a native <details>; close it on outside click and Escape.
    document.addEventListener('click', event => {
      if (this.sortMenu?.open && !this.sortMenu.contains(event.target)) this.sortMenu.open = false;
    }, options);
    this.sortMenu?.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !this.sortMenu.open) return;
      event.preventDefault();
      this.sortMenu.open = false;
      this.sortMenu.querySelector('summary')?.focus();
    }, options);
    if (!this.dialog || !this.form || typeof this.dialog.showModal !== 'function') return;

    this.fallback?.setAttribute('hidden', '');
    this.overlay = new OverlayLifecycle(this.dialog, {
      focus: () => this.closeButton,
      beforeClose: () => this.form.reset(),
    });
    this.openButton?.addEventListener('click', () => this.overlay.open(this.openButton), options);
    this.closeButton?.addEventListener('click', () => this.overlay.close(), options);
    this.form.addEventListener('submit', event => this.apply(event), options);
    window.addEventListener('pageshow', event => {
      if (event.persisted) this.resetSubmission();
    }, options);
    this.openButton?.removeAttribute('hidden');
  }

  disconnectedCallback() { this.disconnect(); }

  disconnect() {
    this.overlay?.dispose();
    this.overlay = null;
    this.controller?.abort();
    this.controller = null;
  }

  resetSubmission() {
    this.pendingNavigation = false;
    this.pendingSubmitter?.removeAttribute('disabled');
    this.pendingSubmitter = null;
  }

  async apply(event) {
    event.preventDefault();
    if (this.pendingNavigation) return;
    const target = new URL(this.form.action, window.location.href);
    const params = new window.URLSearchParams();
    for (const [name, value] of new FormData(this.form)) {
      if (typeof value === 'string' && value.trim() !== '') params.append(name, value);
    }
    const controller = this.controller;
    this.pendingNavigation = true;
    const submitter = event.submitter?.matches?.('button') ? event.submitter : this.form.querySelector('[type="submit"]');
    submitter?.setAttribute('disabled', '');
    this.pendingSubmitter = submitter;
    target.search = params.toString();
    await this.overlay.close();
    if (controller !== this.controller || controller?.signal.aborted || !this.isConnected) return;
    window.location.assign(target.href);
  }
}

if (typeof window !== 'undefined' && !customElements.get('fl-collection-filter-controller')) {
  customElements.define('fl-collection-filter-controller', CollectionFilterController);
}
